import type { TranslatableString } from '~/types/widgets/widgetTypes'
import getWidgetTextTranslation from './getWidgetTextTranslation'

export default (productSlug?: TranslatableString) => {
  const productSlugByLocale = getWidgetTextTranslation(productSlug)

  const formattedUrl = /\/?[a-zA-Z]{2}\/p\//.test(productSlugByLocale)
    ? productSlugByLocale.slice(productSlugByLocale?.[0] === '/' ? 6 : 5, productSlugByLocale.length)
    : productSlugByLocale

  const [slug, productVariant] = formattedUrl.split('?')
  let formattedSlug = slug

  if (slug.endsWith('/')) {
    formattedSlug = formattedSlug.slice(0, -1)
  }

  const variantNumber = productVariant ? productVariant.replace('productVariant=', '') : undefined

  return { productSlugByLocale, slug: formattedSlug, variantNumber }
}
